import * as adminActions from '../actions/admin.action';

export interface State {
  allBookings: any[];
  bookingsCount: number;
  groupASessionCounts: any;
  groupBSessionCounts: any;
  bookingsByCountryCounts: any;
  bookingsByGenderCounts: any;
  error: any;
}

const initialState: State = {
  allBookings: [],
  bookingsCount: 0,
  groupASessionCounts: [],
  groupBSessionCounts: [],
  bookingsByCountryCounts: [],
  bookingsByGenderCounts: [],
  error: null
};

export function reducer(
  state = initialState,
  action: adminActions.adminActions
) {
  switch (action.type) {
    case adminActions.GET_ALL_BOOKINGS_SUCCESS: {
      const allBookings = action.payload;
      const bookingsCount = allBookings.length;
      return {
        ...state,
        allBookings,
        bookingsCount
      };
    }
    case adminActions.GET_ALL_BOOKINGS_FAIL: {
      const error = action.payload;
      return {
        ...state,
        error
      };
    }

    case adminActions.BOOKINGS_BY_GROUP_A_SESSION_COUNT: {
      return {
        ...state,
        groupASessionCounts: [...action.payload.counts]
      };
    }

    case adminActions.BOOKINGS_BY_GROUP_B_SESSION_COUNT: {
      return {
        ...state,
        groupBSessionCounts: [...action.payload.counts]
      };
    }

    case adminActions.BOOKINGS_BY_COUNTRY: {
      return {
        ...state,
        bookingsByCountryCounts: [...action.payload.counts]
      };
    }

    case adminActions.BOOKINGS_BY_GENDER: {
      return {
        ...state,
        bookingsByGenderCounts: [...action.payload.counts]
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/reducers/admin.reducer.ts